var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasData)?_c('e-chart',{style:(("height: " + (this.height) + "px;")),attrs:{"options":_vm.chartOptions,"autoresize":""}}):_c('div',{staticClass:"mt-1-5"},[_vm._v(_vm._s(_vm.$t("No Data Available")))])}
var staticRenderFns = []

export { render, staticRenderFns }